import React from 'react';
import './Welcome.css';
import GoogleSignin from '../img/web_dark_rd_ctn@1x.png';
import MainImg from '../img/undraw_quick_chat_re_bit5 (1).svg';
// import MainImg from '../img/undraw_quick_chat_re_bit5 (1).svg';
import { auth } from '../firebase';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

const Welcome = () => {
    const googleSignIn = () => {
        const provider = new GoogleAuthProvider();
        signInWithPopup(auth, provider);
    };

    return (
        <main className='Welcome'>
            <div className='welcomeContainer'>
                <img
                    src={MainImg}
                    alt='Main page back'
                    className='mainImg'
                ></img>{' '}
                <button className='signIn'>
                    <img
                        onClick={googleSignIn}
                        src={GoogleSignin}
                        alt='sign in with google'
                        type='button'
                    />
                </button>
            </div>
        </main>
    );
};
export default Welcome;
